const waitHtml = require('./wait.html')
  .replace('${message}', gettext('Пожалуйста, подождите.'));

require('./frame-view.component.scss');

class FrameViewController {
  constructor($scope, $timeout, $element, $compile, rx, RouterService, FrameLoadService) {
    this.$scope = $scope;
    this.$timeout = $timeout;
    this.$element = $element;
    this.$compile = $compile;
    this.RouterService = RouterService;
    this.FrameLoadService = FrameLoadService;
    this.handleOnLoad = false;
    this.reload = false;
    this.$scope.$on('beforePrint', () => {
      this.beforePrint();
    });
    this.$scope.$on('afterPrint', () => {
      this.afterPrint();
    });
    let subscriptions = [
      rx.Observable.merge(
        $scope.$toObservable('$ctrl.src'),
        $scope.$toObservable('$ctrl.maximize'),
        $scope.$eventToObservable('reload')
          .do(() => {
            this.reload = true;
            //console.log('frame reload');
          }),
      )
        .debounce(200)
        .subscribe(() => {
          this.updateSrc();
        }),
    ];
    // $scope.$watch('$ctrl.src', (value) => {
    //   console.log('frame source changed', value);
    // });
    $scope.$on('$destroy', () => {
      subscriptions.forEach((s) => s.dispose());
      if (this.iframe) {
        this.FrameLoadService.removeFrame(this.iframe[0]);
      }
    });
  }

  $onInit() {
  }

  $onDestroy() {
  }

  updateSrc() {
    //console.log('frame update src');
    if (this.iframe) {
      let src = this.iframe[0].contentWindow.document.location.pathname +
        this.iframe[0].contentWindow.document.location.search;
      if (this.src === src && !this.reload) {
        return;
      }
      //console.log('frame removed');
      this.iframe[0].removeEventListener('load', this.onload);
      this.FrameLoadService.removeFrame(this.iframe[0]);
      this.iframe.remove();
      this.iframe = null;
    }
    this.reload = false;
    if (!this.src || typeof this.maximize === 'undefined') {
      return;
    }
    if (this.maximize) {
      this.iframe = angular.element(
        `<iframe frameborder="0" scrolling="no"></iframe>`);
    } else {
      this.iframe = angular.element(
        `<iframe frameborder="0" class="maximize"></iframe>`);
    }
    this.$element.append(this.iframe);
    const frame = this.iframe[0];
    this.FrameLoadService.addFrame(frame);
    frame.contentWindow.document.body.innerHTML = waitHtml;
    frame.src = this.src;
    this.onload = () => {
      if (this.onFrameLoad) {
        this.onFrameLoad({frame});
      }
      frame.setAttribute('sc-loaded', true);
      //console.log('frame loaded');
      if (this.maximize) {
        frame.style['min-height'] = Math.max(
          this.minHeight || 0,
          frame.contentDocument.body.scrollHeight,
        ) + 'px';
        frame.style['min-width'] = frame.contentDocument.body.scrollWidth + 'px';
      }
      //console.log('frame width', this.iframe.width());
      //console.log('frame height', this.iframe.height());
      if (!frame.contentWindow) {
        //console.log('frame.contentWindow is null');
        return;
      }
      if (this.handleOnLoad) {
        let src = frame.contentWindow.document.location.pathname +
          frame.contentWindow.document.location.search;
        if (this.src !== src) {
          this.src = src;
          //console.log('frame router open');
          this.RouterService.openFrame(src);
          this.$scope.$root.$digest();
        }
        //console.log('frame setup');
        frame.contentWindow.document.addEventListener('click', (e) => {
          let node = e.target;
          while (node && node.localName !== 'a') {
            node = node.parentNode;
          }
          if (node && node.href &&
            (node.href.startsWith('/') || node.href.startsWith('http'))) {
            const src = node.pathname + node.search;
            this.RouterService.openFrame(src);
            e.preventDefault();
            this.$scope.$root.$digest();
            return false;  // stop handling the click
          }
          return true;
        });
      }
    };
    this.iframe[0].addEventListener('load', this.onload, false);
    //this.$compile(this.iframe)(this.$scope);
    if (this.onFrameCreate) {
      this.onFrameCreate({frame});
    }
  }

  beforePrint() {
    if (!this.iframe) {
      return;
    }
    if (this.maximize) {
      this.iframe[0].style.height = this.iframe[0].contentDocument.body.scrollHeight + 'px';
      this.iframe[0].style.width = this.iframe[0].contentDocument.body.scrollWidth + 'px';
      this.iframe[0].setAttribute('scrolling', 'no');
    } else {
      this.iframe[0].style.height = (this.iframe.width() * 0.618) + 'px';
    }
    //console.log('frame print width', this.iframe.width());
    //console.log('frame print height', this.iframe.height());
  }

  afterPrint() {
    if (!this.iframe) {
      return;
    }
    this.iframe[0].style.removeProperty('height');
    this.iframe[0].style.removeProperty('width');
    if (this.maximize) {
      this.iframe[0].removeAttribute('scrolling');
    }
  }
}

export const FrameViewComponent = {
  template  : require('./frame-view.component.html'),
  bindings  : {
    src          : '<',
    maximize     : '<',
    minHeight    : '<?',
    onFrameCreate: '&?',
    onFrameLoad  : '&?',
    handleOnLoad : '<?',
  },
  controller: FrameViewController,
};



// WEBPACK FOOTER //
// ./src/view/frame-view.component.js